// extracted by mini-css-extract-plugin
export default {"success":"styles_success__+Tmq2","copy":"styles_copy__byjl9"};